import PropTypes from 'prop-types';
import React from 'react';

import Popup from '../Popup';
import Modal from '../Modal';
import BlockControl from '../BlockControl';
import IconBlockType from '../ui/IconBlockType';

import Wrapper from './Wrapper';
import ControlsTop from './ControlsTop';
import IconBlockTypeWrapper from './IconBlockTypeWrapper';
import IconDelete from './IconDelete';

export class BlockControls extends React.PureComponent {
  render() {
    return (
      <Wrapper>
        <IconBlockTypeWrapper>
          <IconBlockType type={this.props.blockType} bold />
        </IconBlockTypeWrapper>

        <ControlsTop>
          {this.props.blockButtons.map(Button => (
            <div key={Button.key}>{Button}</div>
          ))}
        </ControlsTop>

        <BlockControl
          onClick={this.props.onClickRemove}
          icon={IconDelete}
          title="Удалить блок"
        >
          {this.props.showDeleteConfirmation && (
            <Popup
              position="left"
              onClickOutside={this.props.onClickDismissRemoveModal}
            >
              <Modal
                title="Удалить блок?"
                description="Действие необратимо"
                icon={IconDelete}
                buttons={[{
                  text: 'Отмена',
                  type: 'dismiss',
                  onClick: this.props.onClickDismissRemoveModal,
                }, {
                  text: 'Удалить',
                  type: 'confirm',
                  onClick: this.props.onClickConfirmRemove,
                }]}
              />
            </Popup>
          )}
        </BlockControl>
      </Wrapper>
    );
  }
}

BlockControls.propTypes = {
  blockButtons: PropTypes.node,
  blockType: PropTypes.node,
  showDeleteConfirmation: PropTypes.bool,

  onClickRemove: PropTypes.func.isRequired,
  onClickConfirmRemove: PropTypes.func.isRequired,
  onClickDismissRemoveModal: PropTypes.func.isRequired,
};

export default BlockControls;
